import type { Template } from "@/types";

export const PO_05_H0_V5: Template[] = [
{
    id: "po-05-h0v5-01",
    name: "PO 01 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 78, y: 264, width: 190, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 276, y: 264, width: 190, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 474, y: 264, width: 190, height: 326, rotation: 0, imageRotation: 0 },
            { id: "4", x: 672, y: 264, width: 189, height: 326, rotation: 0, imageRotation: 0 },
            { id: "5", x: 869, y: 264, width: 189, height: 326, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h0v5-02",
    name: "PO 02 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 241, width: 221, height: 374, rotation: 0, imageRotation: 0 },
        { id: "2", x: 229, y: 241, width: 221, height: 374, rotation: 0, imageRotation: 0 },
        { id: "3", x: 458, y: 241, width: 221, height: 374, rotation: 0, imageRotation: 0 },
        { id: "4", x: 687, y: 241, width: 221, height: 374, rotation: 0, imageRotation: 0 },
        { id: "5", x: 916, y: 241, width: 220, height: 374, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-03",
    name: "PO 03 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 112, y: 283, width: 169, height: 288, rotation: 0, imageRotation: 0 },
        { id: "2", x: 289, y: 283, width: 168, height: 288, rotation: 0, imageRotation: 0 },
        { id: "3", x: 594, y: 283, width: 167, height: 288, rotation: 0, imageRotation: 0 },
        { id: "4", x: 769, y: 283, width: 167, height: 288, rotation: 0, imageRotation: 0 },
        { id: "5", x: 944, y: 283, width: 167, height: 288, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-04",
    name: "PO 04 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 52, y: 166, width: 309, height: 522, rotation: 0, imageRotation: 0 },
        { id: "2", x: 369, y: 166, width: 153, height: 257, rotation: 0, imageRotation: 0 },
        { id: "3", x: 369, y: 431, width: 153, height: 257, rotation: 0, imageRotation: 0 },
        { id: "4", x: 609, y: 225, width: 239, height: 405, rotation: 0, imageRotation: 0 },
        { id: "5", x: 856, y: 225, width: 238, height: 405, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-05",
    name: "PO 05 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 75, y: 166, width: 319, height: 522, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 401, y: 166, width: 104, height: 169, rotation: 0, imageRotation: 0 },
        { id: "3", x: 401, y: 343, width: 104, height: 169, rotation: 0, imageRotation: 0 },
        { id: "4", x: 401, y: 520, width: 104, height: 168, rotation: 0, imageRotation: 0 },
        { id: "5", x: 697, y: 166, width: 311, height: 522, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-06",
    name: "PO 06 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 88, y: 95, width: 392, height: 664, rotation: 0, imageRotation: 0 },
        { id: "2", x: 656, y: 95, width: 193, height: 328, rotation: 0, imageRotation: 0 },
        { id: "3", x: 656, y: 431, width: 193, height: 328, rotation: 0, imageRotation: 0 },
        { id: "4", x: 857, y: 95, width: 192, height: 328, rotation: 0, imageRotation: 0 },
        { id: "5", x: 857, y: 431, width: 192, height: 328, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-07",
    name: "PO 07 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 83, y: 227, width: 236, height: 399, rotation: 0, imageRotation: 0 },
        { id: "2", x: 327, y: 164, width: 155, height: 259, rotation: 0, imageRotation: 0 },
        { id: "3", x: 327, y: 431, width: 155, height: 259, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 227, width: 236, height: 399, rotation: 0, imageRotation: 0 },
        { id: "5", x: 857, y: 227, width: 235, height: 399, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-08",
    name: "PO 08 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 83, y: 93, width: 403, height: 668, rotation: 0, imageRotation: 0 },
        { id: "2", x: 636, y: 164, width: 319, height: 527, rotation: 0, imageRotation: 0 },
        { id: "3", x: 962, y: 164, width: 103, height: 171, rotation: 0, imageRotation: 0 },
        { id: "4", x: 962, y: 343, width: 103, height: 170, rotation: 0, imageRotation: 0 },
        { id: "5", x: 962, y: 521, width: 103, height: 170, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-09",
    name: "PO 09 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 64, y: 184, width: 282, height: 487, rotation: 0, imageRotation: 0 },
        { id: "2", x: 354, y: 184, width: 140, height: 240, rotation: 0, imageRotation: 0 },
        { id: "3", x: 354, y: 432, width: 140, height: 239, rotation: 0, imageRotation: 0 },
        { id: "4", x: 502, y: 184, width: 281, height: 487, rotation: 0, imageRotation: 0 },
        { id: "5", x: 791, y: 184, width: 280, height: 487, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-10",
    name: "PO 10 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 64, y: 184, width: 282, height: 487, rotation: 0, imageRotation: 0 },
        { id: "2", x: 354, y: 184, width: 282, height: 487, rotation: 0, imageRotation: 0 },
        { id: "3", x: 644, y: 184, width: 281, height: 487, rotation: 0, imageRotation: 0 },
        { id: "4", x: 933, y: 184, width: 140, height: 240, rotation: 0, imageRotation: 0 },
        { id: "5", x: 933, y: 432, width: 140, height: 239, rotation: 0, imageRotation: 0 }
    ],
}
];